export const REVIEWER_TYPES = {
  SEEKER: 1,
  LISTER: 2,
};
